<template>
  <div class="trygamerecord-box">
    <van-nav-bar
      title="试玩记录"
      left-arrow
      fixed
      :border="false"
    >
      <template #left>
        <div class="left-nr" @click="$router.back()">
          <img src="../../assets/yz/monthIcon/yz_monthCard_fh.png" alt="" />
        </div>
      </template>
    </van-nav-bar>
    <div class="record-content">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell v-for="(item, i) in state.list" :key="i + '-list'">
          <template #value>
            <div class="task-item">
              <div class="task-info">
                <h3>{{ item.title }}</h3>
                <p>
                  试玩奖励：<span>{{ item.reward_description }}</span>
                </p>
                <p>领取时间：{{ item.task_log_time }}</p>
                <p v-if="item.finished == 1">
                  完成时间：{{ item.finish_time }}
                </p>
              </div>
              <p v-if="item.finished == 0" style="color: #ff6666">未完成</p>
              <p v-else-if="item.finished == 1" style="color: #2acbaf">
                已完成
              </p>
              <p v-else-if="item.finished == -2" style="color: #ff9630">
                已结束
              </p>
              <p v-else-if="item.finished == -9" style="color: #ff9630">
                人数已满
              </p>
              <p v-else-if="item.finished == 0" style="color: #ff9630">
                人数已满
              </p>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";
import { logInfo, achieveTrial } from "@/api/task";
import { useStore } from "vuex";
import { dateMD } from "@/utils/date";
import defaultimg1 from "@/assets/defaultimg/error2.png";
import { getQueryString } from "../../utils/location";

export default {
  name: "trygamerecord",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      noimg: defaultimg1,
      list: [],
      loading: false,
      finished: false,
    });
    const trygameRecord = (page) => {
      let totalPage;
      logInfo({
        page: page,
        username: getQueryString("username"),
      }).then((response) => {
        console.log("response.data.data-----", response.data.data);
        if (response.data.code == "1") {
          totalPage = response.data.data.totalPage;
          let list = response.data.data.logInfo;
          state.list = state.list.concat(list);
          // 加载状态结束
          state.loading = false;
          // 数据全部加载完成
          if (page >= totalPage) {
            state.finished = true;
          }
        } else {
          state.finished = true;
          Toast(response.data.msg);
        }
      });
    };

    let page = 1;
    // 加载数据
    const onLoad = () => {
      // 异步更新数据

      trygameRecord(page);
      page++;
    };
    return {
      state,
      onLoad,
    };
  },
};
</script>

<style scoped src="../../styles/removeVantcell.css"></style>
<style scoped="scoped">
.van-nav-bar {
  padding-top: calc(60px + constant(safe-area-inset-top)) !important;
  padding-top: calc(60px + env(safe-area-inset-top)) !important;
}

:deep(.van-nav-bar) {
  /* background: #fff; */
  padding-top: 32px;
}
:deep(.van-nav-bar__title) {
  color: #333;
}
:deep(.left-nr img) {
  width: 62px;
  height: 62px;
}

.trygamerecord-box {
  height: 100vh;
  overflow: auto;
  padding-top: calc(180px + constant(safe-area-inset-top));
  padding-top: calc(180px + env(safe-area-inset-top));
}
.record-content {
  padding: 30px;
  padding-top: 0;
}
.task-item {
  background: #fff;
  padding: 30px 30px 12px 30px;
  display: flex;
  border-radius: 20px;
  box-shadow: 0px 4px 28px 0px rgba(182, 182, 185, 0.2);
  margin-top: 20px;
}
.task-item img {
  width: 120px;
  height: 120px;
}
.task-item .task-info {
  width: 100%;
  flex: 1;
}
.task-item .task-info h3 {
  font-size: 30px;
  color: #333;
  margin-bottom: 12px;
}
.task-item .task-info p {
  font-size: 24px;
  margin-bottom: 12px;
  color: #333;
}
.task-item > p {
  font-size: 28px;
}
</style>
